import ReactDOM from 'react-dom';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import './css/estilo.css';

ReactDOM.render(<App />, document.getElementById('root')
);
